export default __webpack_public_path__ + "content/media/24.6dff75a3.jpg";